import { render, staticRenderFns } from "./CbxAssetType.vue?vue&type=template&id=1d586946&"
import script from "./CbxAssetType.vue?vue&type=script&lang=ts&"
export * from "./CbxAssetType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports